import { TopListColumnLabels } from '@/models/top-list/top-list-column-labels.model';
import { TopListColumnMap } from '@/models/top-list/top-list-column-map.model';
import { TopListColumnProperties } from '@/models/top-list/top-list-column-properties.model';
import { TopListTableType } from '@/models/top-list/top-list-table-type.model';
import { TopPlayerListItem } from '@/models/top-list/top-player-list.model';
import { sanitizeNumber } from '@/regex/sanitize-number.regex';

export const TOP_LIST_COLUMN_LIST: TopListColumnMap = {
  [TopListTableType.PLAYERS]: [
    {
      label: TopListColumnLabels.PLAYER,
      prop: TopListColumnProperties.PLAYER_EMAIL,
      width: 350,
    },
    {
      label: TopListColumnLabels.TOTAL_BETS,
      prop: TopListColumnProperties.STAKE_AMOUNT,
    },
    {
      label: TopListColumnLabels.TOTAL_WINS,
      prop: TopListColumnProperties.WIN_AMOUNT,
    },
    {
      label: TopListColumnLabels.GGR,
      prop: TopListColumnProperties.GGR_AMOUNT,
      cellClass:
        (row: TopPlayerListItem) => Number(row[TopListColumnProperties.GGR_AMOUNT]?.replace(sanitizeNumber, '')) > 0
          ? 'top-list__cell_success'
          : 'top-list__cell_danger',
    },
    {
      label: TopListColumnLabels.NGR,
      prop: TopListColumnProperties.NGR_AMOUNT,
      cellClass:
        (row: TopPlayerListItem) => Number(row[TopListColumnProperties.NGR_AMOUNT]?.replace(sanitizeNumber, '')) > 0
          ? 'top-list__cell_success'
          : 'top-list__cell_danger',
    },
    {
      label: TopListColumnLabels.RTP,
      prop: TopListColumnProperties.RTP_PERCENT,
    },
  ],
  [TopListTableType.WINS]: [
    {
      label: TopListColumnLabels.PLAYER,
      prop: TopListColumnProperties.PLAYER_EMAIL,
      width: 350,
    },
    {
      label: TopListColumnLabels.GAME,
      prop: TopListColumnProperties.GAME_NAME,
      width: 250,
    },
    {
      label: TopListColumnLabels.BET,
      prop: TopListColumnProperties.STAKE_AMOUNT,
    },
    {
      label: TopListColumnLabels.WIN,
      prop: TopListColumnProperties.WIN_AMOUNT,
      cellClass: () => 'top-list__cell_warning',
    },
    {
      label: TopListColumnLabels.DATE,
      prop: TopListColumnProperties.END_ACTION_TIME,
      width: 150,
    },
    {
      label: TopListColumnLabels.ROUND_ID,
      prop: TopListColumnProperties.ROUND_ID,
      width: 300,
    },
  ],
} as const;
